const DIALOG_CLASS = 'adobe-fonts-dialog';

/**
 * Attach a dialog to the page.
 * @param {string} template - The HTML template for the dialog.
 * @returns {HTMLElement} - The dialog element.
 */
export const attachDialog = (template) => {
  if (document.querySelector(`.${DIALOG_CLASS}`)) {
    return;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(template, 'text/html');
  const dialogContent = doc.body.firstElementChild;

  const spTheme = document.querySelector('sp-theme');
  const dialog = document.createElement('dialog');
  dialog.classList.add(DIALOG_CLASS);
  dialog.appendChild(dialogContent);

  // Attach dialog within sp-theme to use spectrum css tokens
  spTheme.appendChild(dialog);
  dialog.showModal();

  return dialog;
};

export const closeDialog = () => {
  const dialog = document.querySelector(`.${DIALOG_CLASS}`);
  dialog.close();
  dialog.remove();
};
